var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#991B1B",
    fillRule: "evenodd",
    d: "M17.413 12.238 22 4.862h-4.113l-2.25 3.788z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DC2626",
    fillRule: "evenodd",
    d: "m9.05 5 6.825 14.15h4.137L12.976 4.862H8.988s.05.088.075.138",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#991B1B",
    fillRule: "evenodd",
    d: "m2 4.862 5.225 10.263-2.375 4.012h4.175l3.325-5.524-1.8-3.75L9.4 11.8 6 4.862z",
    clipRule: "evenodd"
  })));
};
export default SvgLogo;